import { EvaCompanyService } from "src/app/features/eva-company/services/evaCompany.service";

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AdminPermissionGuard {
  constructor(
    private evaCompanyService: EvaCompanyService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.evaCompanyService.hasAccountantRights()) {
      this.router.navigate(["/home"]);
      return false;
    }

    if (this.evaCompanyService.hasAdminRights()) return true;

    const current_pos = this.evaCompanyService.getCurrentEvaEmployee().employee_position_current;
    const requiredPermission = route.data["permission"];

    if (!current_pos || !requiredPermission) {
      this.router.navigate(["/home"]);
      return false;
    }

    if (current_pos[requiredPermission] === true) return true;

    this.router.navigate(["/home"]);
    return false;
  }
}
